import { interceptAxios, getGlobalNamespace } from '@patsnap-utils/passport';
import { psAxios } from '@patsnap/common-ps-http';

// eslint-disable-next-line no-unused-vars
export const passportInterceptManager = {
    inject() {
        if (!psAxios.psInterceptors.passportRequestInterceptor) {
            interceptAxios(psAxios);
        }
    },
    eject() {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.passportRequestInterceptor);
        psAxios.interceptors.response.eject(psAxios.psInterceptors.passportResponseInterceptor);
        delete psAxios.psInterceptors.passportRequestInterceptor;
        delete psAxios.psInterceptors.passportResponseInterceptor;
    },
};

export function getPassport() {
    return getGlobalNamespace().singletonPassport;
}
